<nav class="col-sm-auto side-bar">
<app-navigation-btn-panel></app-navigation-btn-panel>
</nav>
<ng-container *ngIf="slider.showslider">
    <ng-container *ngIf="slider.isfiltersearch">
      <app-slider (isClose)="closeHandler(result)" [isFilterSearch]="true" [sliderTitle]='""'>
      </app-slider>
     </ng-container>
     <ng-container *ngIf="slider.iscreatesearch">
         <app-slider (isClose)="closeHandler(result)" [isCreateSearch]="true"></app-slider>
     </ng-container>
     <ng-container *ngIf="slider.isgeneratereport">
        <app-slider (isClose)="closeHandler(result)" [isGenerateReport]="true"></app-slider>
    </ng-container>
    <ng-container *ngIf="slider.isadduser">
        <app-slider (isClose)="closeHandler(result)" [isAddUsers]="true"></app-slider>
    </ng-container>
    <ng-container *ngIf="slider.isaddline">
            <app-slider (isClose)="closeHandler(result)" [isAddLine]="true"></app-slider>
        </ng-container>
</ng-container>

